@if (providerLogo) {
  <img [src]="providerLogo" />
} @else {
  @if (providerTitle) {
    <h2>{{ providerTitle }}</h2>
  } @else {
    @if (logo) {
      <img class="lad-logo" [src]="logo" alt="" />
    }
  }
}
